export default {
    '/': 'Home',
    '/about': 'About',
    '/Games/MineSweep':'Games/MineSweep',
    '/Games/ChineseChess':'Games/ChineseChess',
  }